<template>
  <div id="mainNotice">
    <table class="type3">
      <thead slot="head">
        <th>No</th>
        <th>SITE</th>
        <th>TITLE</th>
      </thead>
      <tbody slot="body">
        <tr v-for="row in values" :key="row.id">
          <td width="30" class="num tah font999" style="font-size:9pt;">{{row.num}}</td>
          <td width="70" class="tah text-center" style="font-size:9pt;color:#353535">{{row.kind}}</td>
          <td>
            <span v-html="row.retValue"></span>
          </td>
        </tr>
      </tbody>
    </table>

    <div class="block" style="padding:5px 0;" align="center">
      <el-pagination
        background
        layout="prev, pager, next"
        small
        :page-size="20"
        :total="total"
        @current-change="pageChangeHandler"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: 'mainNotice',
  data () {
    return {
      values: [],
      total: 0
    }
  },
  methods: {
    fetchData: function (page) {
      this.$axios
        .get('https://wisebody.co.kr/api/getNotice.php', {
          params: {
            page: page
          }
        })
        .then(res => {
          if (res.status === 200) {
            this.$root.$refs.H.lastUpdateDate = res.data.WDATE
            this.$root.$refs.MENU.TCAP = res.data.TCAP
            this.$root.$refs.MENU.TPER = res.data.TPER
            this.$root.$refs.MENU.TBTC = res.data.TBTC
            this.$root.$refs.MENU.TBTCPER = res.data.TBTCPER
            this.$root.$refs.MENU.usd_naver_top = res.data.AUSD_TOP
            this.values = res.data.list
            this.$root.$refs.F.usd_naver = res.data.AUSD
            this.$root.$refs.F.usdt = res.data.AUSDT
            this.total = res.data.TotalCount
          } else {
            console.log('Server Error')
          }
        })
        .catch(e => {
          console.error(e.message)
        })
    },
    pageChangeHandler: function (e) {
      this.fetchData(e)
    }
  },
  created () {
    this.$root.$refs.M = this
    this.fetchData(1)
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/notice.vue